:host {
  .margin-right-5 {
    margin-right: 5px;
  }

  .message-ticket {
    .message-ticket-title {
      margin-bottom: 20px;
      a {
        text-decoration: none;
        color: #0098ff;
        color: var(--blue);
      }
    }
    .message-ticket-actions {
      button {
        cursor: pointer;
        background: white;
        background: var(--bg-primary);
        color: #0098ff;
        color: var(--blue);
        border: 1px solid #0098ff;
        border: 1px solid var(--blue);
        border-radius: 6px;
        width: 100%;
        padding: 10px 15px;
        margin-bottom: 10px;

        &:focus {
          outline: none;
        }

        &:hover {
          transition: 0.3s;
          background: #0098ff;
          background: var(--blue);
          color: white;
        }

        &:last-child {
          margin-bottom: 0;
        }

        &:disabled {
          background: rgba(0, 0, 0, 0.12);
          background: var(--bg-disabled-button);
          border: none;
          color: rgba(0, 0, 0, 0.26);
          color: var(--font-disabled);
          cursor: not-allowed;
        }
      }
    }
  }

  .ticket-core-tickets {
    .ticket-core-ticket {
      .title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        &__round {
          width: 8px;
          height: 8px;
          margin-right: 5px;
          display: block;
          border-radius: 50%;
        }

        &__status {
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 20px;
        }
      }

      .description {
        color: #666666;
        color: var(--font-secondary);
        font-size: 16px;
        letter-spacing: 0;
        line-height: 21px;
        margin-bottom: 10px;
      }

      .action {
        button {
          cursor: pointer;
          background: white;
          background: var(--bg-primary);
          color: #0098ff;
          color: var(--blue);
          border: 1px solid #0098ff;
          border: 1px solid var(--blue);
          border-radius: 6px;
          width: 100%;
          padding: 10px 15px;
          margin-bottom: 10px;

          &:focus {
            outline: none;
          }

          &:hover {
            transition: 0.3s;
            background: #0098ff;
            background: var(--blue);
            color: white;
          }

          &:last-child {
            margin-bottom: 0;
          }

          &:disabled {
            background: rgba(0, 0, 0, 0.12);
            background: var(--bg-disabled-button);
            border: none;
            color: rgba(0, 0, 0, 0.26);
            color: var(--font-disabled);
            cursor: not-allowed;
          }
        }
      }

      .last-row {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .date {
          color: #979ba4;
          color: var(--font-tertiary);
          font-size: 14px;
          letter-spacing: 0;
          line-height: 21px;
        }

        .ticket-id {
          color: #979ba4;
          color: var(--font-tertiary);
          margin-left: 20px;
        }
      }

      &--mobile {
        .last-row {
          align-items: flex-start;
          flex-direction: column;

          .ticket-id {
            margin-left: 0;
          }
        }
      }
    }
  }
}
